import React, { useState, useCallback, useEffect, useMemo } from "react";
import { Modal, Select, Popover, Input, Button } from "antd";
import { DeleteOutlined, EllipsisOutlined } from "@ant-design/icons";
import images from "../../../themes/appImage";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  dummyUserPostLikeLoad,
  dummyUserpostLikeFail,
} from "../../../redux/slices/engagementFarming.slice";
import { dummyUserListLoad } from "../../../redux/slices/createUser.slice";
import { imageURL } from "../../../redux/Api/apikit";
import moment from "moment";
import { getCommentListLoad } from "../../../redux/slices/inner.slice";
import {
  postLikeFail,
  postLikeLoad,
  removePostload,
} from "../../../redux/slices/community.slice";
import {
  removeCommentLoad,
  toxicLoad,
} from "../../../redux/slices/common.slice";
import { toast } from "react-toastify";

const { Option } = Select;
const { TextArea } = Input;

const apiPayloadInit = {
  offset: 0,
  limit: 10,
};

const Content = React.memo(({ emojiData, handleEmojiClick }) => {
  return (
    <div className="flex items-center">
      {emojiData.map((emoji) => (
        <div key={emoji.label} className="mr-2 flex gap-1">
          <img
            src={emoji.src}
            alt={emoji.label}
            className="cursor-pointer w-6 h-6"
            onClick={() => handleEmojiClick(emoji.emojiName)}
          />
        </div>
      ))}
    </div>
  );
});

function Post() {
  const [modalOpen, setModalOpen] = useState(false);
  const [emojiVisible, setEmojiVisible] = useState(false);
  const [dummy, setDummy] = useState({ reaction: "", userId: undefined });
  const [selectedEmoji, setSelectedEmoji] = useState("");
  const [emojiCounts, setEmojiCounts] = useState({});
  const [commentsList, setCommentsList] = useState([]);
  const [apiPayload, setApiPayload] = useState(apiPayloadInit);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [commentText, setCommentText] = useState("");
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);
  const [hasMoreComments, setHasMoreComments] = useState(true);

  const location = useLocation();
  const postData = location.state || {};
  const dispatch = useDispatch();

  const { isPostLikeSuccess } = useSelector(
    (state) => state.engagementFarmingReducer || {}
  );
  const dummyUsers = useSelector(
    (state) => state.createUserReducer?.data?.data?.list || []
  );
  const { commentListData } = useSelector((state) => state.InnerCircleReducer);
  const commonReducerState = useSelector((state) => state.commonReducer);
  const { lastCommentData } = useSelector((state) => state.CommunityReducer);

  const [pagination, setPagination] = useState({ limit: 1000, offset: 0 });

  // Fetch dummy users
  useEffect(() => {
    dispatch(dummyUserListLoad(pagination));
  }, [dispatch, pagination]);

  // Initialize emojis
  const emojiData = useMemo(
    () => [
      { src: images.hug, emojiName: "smileyFace", label: "smileyFace" },
      { src: images.EyeBrows, emojiName: "happyFace", label: "happyFace" },
      { src: images.love, emojiName: "redHeart", label: "redHeart" },
      { src: images.party, emojiName: "partyFace", label: "partyFace" },
      {
        src: images.smileyHeart,
        emojiName: "smileyHeart",
        label: "smileyHeart",
      },
    ],
    []
  );

  // Initialize emoji counts from postData
  useEffect(() => {
    const counts = {};
    emojiData.forEach((emoji) => {
      counts[emoji.emojiName] = postData[emoji.emojiName] || 0;
    });
    setEmojiCounts(counts);
  }, [postData, emojiData]);

  const handleEmojiClick = useCallback((emojiName) => {
    setDummy((prev) => ({ userId: prev?.userId, reaction: emojiName }));
    setSelectedEmoji(emojiName);
    setEmojiVisible(false);
    // setModalOpen(true);
    // handleSubmit();


    const postId = postData?._id || postData?.id;
    console.log('dummy: ', dummy, postId)

    if(!postId) return;

    if (!dummy?.userId) {
      toast.error('Please select user.');
      return;
    } 

    const payload = {
      userId: dummy?.userId,
      typeOfComment: "reaction",
      comment: emojiName,
      post: postId,
    };

    dispatch(dummyUserPostLikeLoad(payload));

    // Update local emoji count
    setEmojiCounts((prev) => ({
      ...prev,
      [emojiName]: (prev[emojiName] || 0) + 1,
    }));
    setOpen(false); // Close the three dots popover
  }, [dummy?.userId]);

  // Reset post like success flag
  useEffect(() => {
    if (isPostLikeSuccess) {
      dispatch(dummyUserpostLikeFail());
    }
  }, [isPostLikeSuccess, dispatch]);

  // Emoji popover content for three dots - All in one line
  const emojiContent = (
    <div className="flex items-center  ">
      {emojiData.map((emoji) => (
        <div
          key={emoji.emojiName}
          className="flex items-center gap-1 cursor-pointer hover:bg-gray-100 p-1 rounded"
          onClick={() => handleEmojiClick(emoji.emojiName)}
        >
          <img src={emoji.src} alt={emoji.emojiName} className="w-6 h-6" />
          {emojiCounts[emoji.emojiName] > 0 && (
            <span className="text-xs min-w-[16px] text-center">
              {emojiCounts[emoji.emojiName]}
            </span>
          )}
        </div>
      ))}
    </div>
  );

  const rawCreatedAt = postData?.createdAt || postData?.creatorData?.createdAt;
  const relativeTime = rawCreatedAt
    ? moment.utc(rawCreatedAt).local().fromNow()
    : "";
  const absoluteTime = rawCreatedAt
    ? moment.utc(rawCreatedAt).local().format("DD MMM YYYY, hh:mm A")
    : "";

  // Submit reaction
  const handleSubmit = () => {
    const postId = postData?._id || postData?.id;
    if (!dummy.userId || !dummy.reaction || !postId) {
      toast.error('Please select user.');
      return;
    } 

    const payload = {
      userId: dummy?.userId,
      typeOfComment: "reaction",
      comment: dummy?.reaction,
      post: postId,
    };

    dispatch(dummyUserPostLikeLoad(payload));

    // Update local emoji count
    setEmojiCounts((prev) => ({
      ...prev,
      [dummy.reaction]: (prev[dummy.reaction] || 0) + 1,
    }));

    setModalOpen(false);
    setDummy(prev=>({...prev, reaction: "" }));
  };

  // Comment modal handlers
  const handelClick = () => {
    setApiPayload((pre) => apiPayloadInit);
    setCommentsList((pre) => []);
    setIsModalVisible((pre) => true);
    const data = {
      limit: 10,
      offset: 0,
      post: postData?._id || postData?.id,
    };
    dispatch(getCommentListLoad(data));
    setHasMoreComments(true);
  };

  const handleClose = () => {
    setApiPayload((pre) => apiPayloadInit);
    setCommentsList((pre) => []);
    setIsModalVisible(false);
    setHasMoreComments(true);
  };

  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  // Load more comments
  const handlerShowMoreCommentsHandler = () => {
    const updateOffset = apiPayload.offset + apiPayload.limit;
    const data = {
      ...apiPayload,
      offset: updateOffset,
      post: postData?._id || postData?.id,
    };
    dispatch(getCommentListLoad(data));
    setApiPayload((pre) => ({ ...pre, offset: updateOffset }));
  };

  // Post comment - IMMEDIATE UI UPDATE
  const postCommentHandler = () => {
    if (!commentText.trim()) return;

    if( !dummy?.userId) {
      toast.error('Please select user.');
      return;
    }

    // Create temporary comment object for immediate UI update
    const tempComment = {
      userId: dummy?.userId,
      comment: commentText,
      commentByAdmin: true,
      createdAt: moment.utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
      userDetail: null,
      _id: `temp-${Date.now()}`, // Temporary ID
      isTemp: true, // Flag to identify temporary comments
    };

    // Add comment to local state immediately
    setCommentsList((prev) => [tempComment, ...prev]);

    // Clear input immediately
    setCommentText("");

    // Dispatch API call
    dispatch(
      toxicLoad({
        userId: dummy?.userId,
        apiKey: process.env.REACT_APP_API_URL,
        comment: commentText,
        typeOfComment: "comment",
        post: postData?._id || postData?.id,
      })
    );
  };

  // Update temporary comment with real data when API succeeds
  useEffect(() => {
    if (isPostLikeSuccess && lastCommentData) {
      // Find and remove the temporary comment
      setCommentsList((prev) => {
        const filtered = prev.filter((comment) => !comment.isTemp);

        // Add the real comment from API at the beginning
        const realComment = {
          comment: lastCommentData.comment,
          commentByAdmin: true,
          createdAt: moment.utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
          userDetail: null,
          _id: lastCommentData.commentId,
        };

        return [realComment, ...filtered];
      });

      dispatch(postLikeFail());
    }
  }, [isPostLikeSuccess, lastCommentData]);

  // Update comments list from API - Append new comments when loading more
  useEffect(() => {
    if (commentListData && commentListData.length > 0) {
      if (apiPayload.offset === 0) {
        // First load - replace all comments but keep any temporary comments
        const tempComments = commentsList.filter((comment) => comment.isTemp);
        setCommentsList([...tempComments, ...commentListData]);
      } else {
        // Load more - append comments to the end
        setCommentsList((prev) => [...prev, ...commentListData]);
      }

      // Check if there are more comments to load
      if (commentListData.length < apiPayload.limit) {
        setHasMoreComments(false);
      }
    }
  }, [commentListData]);

  // Remove comment from list
  useEffect(() => {
    if (commonReducerState?.removeCommentSuccessIds.commentId) {
      const clone = [...commentsList].filter(
        (item) =>
          item._id !== commonReducerState?.removeCommentSuccessIds.commentId
      );
      setCommentsList(clone);
    }
  }, [commonReducerState?.removeCommentSuccessIds.commentId]);

  return (
    <div className="flex flex-col mt-3 items-center bg-gray-100 gap-5 pb-[50px]">
      <h3 className="text-[25px] w-full font-bold ">Post Details</h3>
        <div className="w-[700px] border rounded-xl shadow-lg overflow-hidden bg-white p-5">
          <label className="block mb-2 font-medium">
            Select User
          </label>
          <Select
            className="w-full"
            placeholder="Choose a user"
            value={dummy.userId}
            onChange={(value) =>
              setDummy((prev) => ({ ...prev, userId: value }))
            }
          >
            {dummyUsers?.length > 0 ? (
              dummyUsers.map((user) => (
                <Option key={user._id} value={user._id}>
                  {user.userName}
                </Option>
              ))
            ) : (
              <Option disabled>No users found</Option>
            )}
          </Select>
        </div>
      <div className="w-[700px] border rounded-xl shadow-lg overflow-hidden bg-white">
        <div className="flex items-center justify-between gap-3 p-3 relative">
          <div className="flex items-center gap-3">
            <img
              src={imageURL + postData.creatorData?.avatar}
              alt="dp"
              className="w-10 h-10  rounded-full object-cover"
              crossOrigin="*"
            />
            <div className="flex flex-col">
              <span className="font-semibold text-base">
                {postData.creatorData?.userName || "John Doe"}
              </span>
              <span
                className="text-xs text-gray-500"
                title={absoluteTime || undefined}
              >
                {relativeTime || "N/A"}
              </span>
            </div>
          </div>

          {/* Three dots popover with emojis */}
          <Popover
            content={emojiContent}
            trigger="click"
            open={open}
            onOpenChange={handleOpenChange}
          >
            <EllipsisOutlined className="text-gray-600 text-xl cursor-pointer" />
          </Popover>
        </div>

        {postData.file && (
          <div className="flex justify-center">
            <img
              src={imageURL + postData.file}
              alt="post"
              className="h-[calc(100vh-375px)] object-contain"
              crossOrigin="anonymous"
            />
          </div>
        )}
        <h3 className="text-lg w-full py-5 px-10">{postData.text || "Post"}</h3>

        {/* Display emojis with counts */}
        <div className="flex items-center gap-2 mt-2 px-10">
          {emojiData.map((emoji) => (
            <div key={emoji.emojiName} className="flex items-center gap-1">
              <img src={emoji.src} alt={emoji.emojiName} className="w-6 h-6" />
              <span className="text-sm">
                {emojiCounts[emoji.emojiName] || 0}
              </span>
            </div>
          ))}
        </div>

        {/* Comments section */}
        <div className="px-10 py-5 border-t">
          <div className="flex justify-between items-center mb-4">
            <h4 className="font-semibold">
              Comments ({postData.comment || 0})
            </h4>
            <Button
              type="primary"
              onClick={handelClick}
              className="bg-blue-500 hover:bg-blue-600"
            >
              View Comments
            </Button>
          </div>
        </div>
      </div>

      {/* Reaction User select modal */}
      <Modal
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        footer={null}
        centered
        closeIcon={<span className="text-xl font-bold">×</span>}
      >
        <div>
          <label className="block mb-2 font-medium">
            Select User for Reaction
          </label>
          <Select
            className="w-full"
            placeholder="Choose a user"
            value={dummy.userId}
            onChange={(value) =>
              setDummy((prev) => ({ ...prev, userId: value }))
            }
          >
            {dummyUsers?.length > 0 ? (
              dummyUsers.map((user) => (
                <Option key={user._id} value={user._id}>
                  {user.userName}
                </Option>
              ))
            ) : (
              <Option disabled>No users found</Option>
            )}
          </Select>

          <div className="btn-schedule mt-9 mb-3">
            <button onClick={handleSubmit}>Submit Reaction</button>
          </div>
        </div>
      </Modal>

      {/* Comments Modal */}
      <Modal
        title="Comments"
        visible={isModalVisible}
        onCancel={handleClose}
        footer={null}
        centered
        width={600}
      >
        <div className="h-80 overflow-scroll mb-4">
          {commentsList && commentsList.length > 0 ? (
            commentsList.map((comment) => (
              <div
                key={comment?._id}
                className="mb-4 flex items-center justify-between p-3 border-b"
              >
                <div className="w-[80%]">
                  <div className="flex items-center mb-2">
                    <img
                      src={
                        comment?.commentByAdmin
                          ? images.matleFitLogo
                          : comment?.userDetail?.avatar
                          ? `${imageURL}${comment?.userDetail?.avatar}`
                          : images.userProf
                      }
                      alt="avatar"
                      className="w-8 h-8 object-contain mr-2 rounded-full"
                    />
                    <div className="flex flex-col">
                      <div className="text-sm font-semibold">
                        {comment?.userDetail?.userName || "Admin"}
                      </div>
                      <div className="text-xs text-gray-500">
                        {moment(comment?.createdAt).utc().fromNow()}
                      </div>
                    </div>
                  </div>
                  <div className="text-base font-normal text-dark max-w-[100%]">
                    {comment?.comment}
                  </div>
                </div>
                {!comment?.isTemp && (
                  <DeleteOutlined
                    onClick={() => {
                      dispatch(
                        removeCommentLoad({
                          postId: postData?._id || postData?.id,
                          commentId: comment._id,
                        })
                      );
                    }}
                    style={{ color: "red", cursor: "pointer" }}
                  />
                )}
              </div>
            ))
          ) : (
            <div className="w-full text-center py-8 text-gray-500">
              No comments yet
            </div>
          )}
        </div>

        {/* Load More button - Only show if there are more comments */}
        {hasMoreComments && commentsList.length > 0 && (
          <div className="flex mt-3 mb-3 justify-center">
            <div
              onClick={handlerShowMoreCommentsHandler}
              className="cursor-pointer border rounded-md py-2 px-4 text-sm text-black hover:bg-gray-50"
            >
              Load more comments
            </div>
          </div>
        )}

        <div className="flex items-center gap-2 mt-4">
          <Input
            type="text"
            placeholder="Write your comment here..."
            value={commentText}
            onChange={(e) => setCommentText(e.target.value)}
            onPressEnter={postCommentHandler}
          />
          <Button
            type="primary"
            onClick={postCommentHandler}
            disabled={!commentText.trim()}
            className="bg-blue-500 hover:bg-blue-600"
          >
            Comment
          </Button>
        </div>
      </Modal>
    </div>
  );
}

export default Post;
